var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{staticClass:"data-textarea",class:{
  'data-textarea_disabled': _vm.disabled,
  'data-textarea_error': _vm.error,
  'data-textarea_no-edit': _vm.noEdit,
  'data-textarea_theme-white': _vm.theme === 'white'
},style:({'height': `${_vm.height}px`, 'font-size': `${_vm.fontSize}px`}),attrs:{"disabled":_vm.disabled || _vm.noEdit,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }